// export { client as default } from '../__api/apollo/client'
import {
  ApolloClient,
  from,
  // ApolloLink,
  HttpLink,
  InMemoryCache,
  gql
} from '@apollo/client'
import { api } from 'src/api'
// import { setContext } from '@apollo/link-context'
import fetch from 'isomorphic-fetch'
// import * as resolvers from './resolvers'
// import typeDefs from './typeDefs/index.graphql'
import Cookies from 'universal-cookie'

const textileService =
  typeof window !== 'undefined'
    ? require('src/api/textile').textileService
    : undefined

const cookies = new Cookies()

const link = from([
  new HttpLink({
    uri: '/.netlify/functions/graphql',
    // credentials: "same-origin",
    fetch
  })
])

const IS_LOGGED_IN = gql`
  query IsUserLoggedIn {
    isLoggedIn @client
  }
`

const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        // isLoggedIn:'',
        project(_, {}) {},
        async projects() {
          console.log('GET PROJECTS')
          if (!textileService?.initialized) return []
          const projects = await textileService.getProjects()
          console.log(projects)
          return projects
        }
      }
    },
    Mutation: {
      fields: {
        signup: {
          merge() {}
        },
        confirm: {
          merge(existing, incomming) {}
        },
        login: {
          merge(...args) {
            console.log(args)
            return {}
          },
          read(...args) {
            console.log(args)
            return { token: 'xyz' }
          }
        }
      }
    }
  }
})

const client = new ApolloClient({
  cache,
  link
  // resolvers,
  // typeDefs
})

cache.writeQuery({
  query: IS_LOGGED_IN,
  data: {
    // isLoggedIn: cookies.get('textile')
    //!!localStorage.getItem('token')
  }
})

export { client }
